<template>
    <v-dialog v-model="dialog" width="600px">
        <v-card>
            <v-card-title class="ma-2 justify-center">Add a discount code</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-2"><b>{{ akcd.akcd_oms }}</b></v-card-text>
            <v-divider></v-divider>
            <v-card-text>            
                <v-row no-gutters>  
                    <v-col cols="6" class="px-2">
                        <v-text-field v-model="akcc_code" label="Action code"></v-text-field>
                    </v-col> 
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addAkcc">Save</v-btn>
                <v-btn color="primary"      small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,

                akcc_code: "",
            }
        },
        methods: {
            openDialog(akcd) {
                this.akcd = akcd;
                this.akcc_code = "";
                
                this.dialog = true;
            },
            addAkcc() { 
                this.$axios.post("ares/json/ares/syst/ref/akcd/addAkccv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addAkccv2"
                    },
                    addAkccv2: {
                        akcd_encrid: this.akcd.akcd_encrid,
                        akcc_code: this.akcc_code,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addAkccv2.text,
                            color: res.data.addAkccv2.color
                        }); 
                        if (res.data.addAkccv2.color == "success") {
                            // console.log(res.data.addAkccv2)
                            this.$emit("addedAkcc", res.data.addAkccv2)
                            //this.$router.reload('/syst/ref/akcd/searchAkcd/');  
                            this.dialog = false; 
                        }
                    }
                })
            }
        }
    }
</script>

